export enum BudgetStatus {
  Default = 'DEFAULT',
  NeverBudgeted = 'NEVER BUDGETED',
  NeglectedBudget = 'NEGLECTED BUDGET',
  NewMonth = 'NEW MONTH',
  TrackTransactions = 'TRACK TRANSACTIONS',
  TrackTransactions10Plus = 'TRACK TRANSACTIONS 10 PLUS',
  CaughtUp = 'CAUGHT UP',
  ConnectBank = 'CONNECT BANK',
  TrackTransactionsWithoutBankConnect = 'TRACK TRANSACTIONS WITHOUT BANK CONNECT',
}

export type Budget = { date: string };

export type Transaction = {
  amount: { usd: number };
  date: string;
  merchant: string;
};

export type Registration = {
  id: string;
  name: string;
  url: string;
};

export type Env = 'TEST' | 'QA' | 'PROD';
